import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PayrollScaleDataDTO  {
    _originalTypeClassName = "zERP.BO.PayrollScaleDataDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PayrollScaleDataDTO.translate = translateService;
}
this.Items = [];
this.ChildrenDiscounts = [];
this.Id = null;
this.Code = null;
this.ActiveFrom = null;
this.IsTiered = false;
this.ValueType = null;
this.Version = null;
this.DiscountLimit = null;
this.DiscountLimitReducePercentage = null;
this.GeneralDiscountPerChild = null;
this.PayrollScaleId = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Code:any;
ActiveFrom:any;
IsTiered:any;
ValueType:any;
Version:any;
DiscountLimit:any;
DiscountLimitReducePercentage:any;
GeneralDiscountPerChild:any;
PayrollScaleId:any;
Items:any;
ChildrenDiscounts:any;
PayrollVariable:any;
static setItems = ($this, items) => {
                if (items == null) items = [];
                if ($this.Items == null) $this.Items = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Items.length > 0) {
                    Domain.PayrollScaleDataDTO.removeItems($this, $this.Items[0]);
                }

                Domain.PayrollScaleDataDTO.addManyItems($this, copyItems);
            }
static addManyItems = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.PayrollScaleDataDTO.addItems($this, items[i]);
                }
            }
static addItems = ($this, item) => {
                if ($this.Items == null) $this.Items = [];
                if (item == null || $this.Items.indexOf(item) > -1) return;
                $this.Items.push(item);
}
static addRangeItems = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.PayrollScaleDataDTO.addItems($this, item));
            }
static removeItems = ($this, item) => {
                if ($this == null || $this.Items == null || $this.Items.indexOf(item) === -1) return;
                var _index = $this.Items.indexOf(item);
                $this.Items.splice(_index, 1);
}
static clearItems = ($this) => { $this.Items = null; }
static setChildrenDiscounts = ($this, items) => {
                if (items == null) items = [];
                if ($this.ChildrenDiscounts == null) $this.ChildrenDiscounts = [];

                const copyItems = Common.cloneObject(items);

                while ($this.ChildrenDiscounts.length > 0) {
                    Domain.PayrollScaleDataDTO.removeChildrenDiscounts($this, $this.ChildrenDiscounts[0]);
                }

                Domain.PayrollScaleDataDTO.addManyChildrenDiscounts($this, copyItems);
            }
static addManyChildrenDiscounts = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.PayrollScaleDataDTO.addChildrenDiscounts($this, items[i]);
                }
            }
static addChildrenDiscounts = ($this, item) => {
                if ($this.ChildrenDiscounts == null) $this.ChildrenDiscounts = [];
                if (item == null || $this.ChildrenDiscounts.indexOf(item) > -1) return;
                $this.ChildrenDiscounts.push(item);
}
static addRangeChildrenDiscounts = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.PayrollScaleDataDTO.addChildrenDiscounts($this, item));
            }
static removeChildrenDiscounts = ($this, item) => {
                if ($this == null || $this.ChildrenDiscounts == null || $this.ChildrenDiscounts.indexOf(item) === -1) return;
                var _index = $this.ChildrenDiscounts.indexOf(item);
                $this.ChildrenDiscounts.splice(_index, 1);
}
static clearChildrenDiscounts = ($this) => { $this.ChildrenDiscounts = null; }
static setPayrollVariable = ($this, value) => {
var oldValue = $this.PayrollVariable;
$this.PayrollVariable = value;
if (value != null) {
}
}

static InsertPayrollScaleChildDiscountsDTO($this: any, payrollScaleChildDiscountList: any): any{for (let _ichildDiscount = 0; _ichildDiscount < (payrollScaleChildDiscountList == null ? 0 : payrollScaleChildDiscountList.length); _ichildDiscount++) {let childDiscount = payrollScaleChildDiscountList[_ichildDiscount];let childDiscountDTO = new Domain.PayrollScaleChildDiscountDTO();childDiscountDTO.NumberOfChildren = childDiscount?.NumberOfChildren;childDiscountDTO.Discount = childDiscount?.Discount;$this?.ChildrenDiscounts?.add(childDiscountDTO);}
}
static InsertPayrollVariableDTO($this: any, prVariable: any): any{Domain.PayrollScaleDataDTO.setPayrollVariable($this, new Domain.PayrollVariable_DTO());
$this.PayrollVariable.Name = prVariable?.Name;
$this.PayrollVariable.Code = prVariable?.Code;
$this.PayrollVariable.Description = prVariable?.Description;
$this.PayrollVariable.DefaultValue = prVariable?.DefaultValue;
$this.PayrollVariable.GetValueFromData = prVariable?.GetValueFromData;
$this.PayrollVariable.TrackHistoricData = prVariable?.TrackHistoricData;
$this.PayrollVariable.DatasourceEntityName = prVariable?.DatasourceEntityName;
$this.PayrollVariable.DatasourceFieldName = prVariable?.DatasourceFieldName;
$this.PayrollVariable.Code_ = prVariable?.Code_;
$this.PayrollVariable.report = prVariable?.report;
$this.PayrollVariable.Type = prVariable?.Type;
$this.PayrollVariable.DefinitionLevel = prVariable?.DefinitionLevel;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}